import React from "react";

/* eslint-disable max-len */
function SlideUploadIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={100} height={80} viewBox="0 0 100 80">
            <defs>
                <style>{".c{fill:#b4db6a}.d{fill:#fdf7e6}.e{fill:#d8d0be}"}</style>
                <clipPath id="a">
                    <path d="M0 0H100V80H0z" />
                </clipPath>
            </defs>
            <g clipPath="url(#a)">
                <path
                    d="M100 71.5L71.1 33.2 38.8 56.6 56.5 80H95a4.951 4.951 0 005-5z"
                    fill="#95b35f"
                />
                <path
                    fill="#b4db6a"
                    d="M71.1 33.2L100 71.5V5a4.951 4.951 0 00-5-5H5a4.951 4.951 0 00-5 5v70a4.951 4.951 0 005 5h51.5L38.8 56.6z"
                />
            </g>
            <path
                className="d"
                d="M69.6 58.1H40.9a2.946 2.946 0 01-3-3V35.8a2.946 2.946 0 013-3h28.7a2.946 2.946 0 013 3v19.3a3.009 3.009 0 01-3 3z"
            />
            <path
                fill="#b4db6a"
                d="M65.6 54.3H36.9a2.946 2.946 0 01-3-3V31.9a2.946 2.946 0 013-3h28.7a2.946 2.946 0 013 3v19.3a3.1 3.1 0 01-3 3.1z"
            />
            <path
                className="d"
                d="M64.4 53H35.7a2.946 2.946 0 01-3-3V30.7a2.946 2.946 0 013-3h28.7a2.946 2.946 0 013 3V50a2.946 2.946 0 01-3 3z"
            />
            <path
                fill="#b4db6a"
                d="M60.3 48.9H31.5a2.946 2.946 0 01-3-3V26.6a2.946 2.946 0 013-3h28.7a2.946 2.946 0 013 3v19.3a2.865 2.865 0 01-2.9 3z"
            />
            <path
                className="d"
                d="M59.1 47.8H30.3a2.946 2.946 0 01-3-3V25.4a2.946 2.946 0 013-3H59a2.946 2.946 0 013 3v19.3a2.95 2.95 0 01-2.9 3.1z"
            />
            <path
                fill="#b4db6a"
                d="M58.1 26.8H31.3a.789.789 0 01-.8-.8v-.1a.789.789 0 01.8-.8h26.8a.789.789 0 01.8.8v.1a.789.789 0 01-.8.8z"
            />
            <path
                className="e"
                d="M58.1 41.9H31.3a.789.789 0 01-.8-.8V41a.789.789 0 01.8-.8h26.8a.789.789 0 01.8.8.817.817 0 01-.8.9zM58.1 30.3H47.8a.789.789 0 01-.8-.8v-.1a.789.789 0 01.8-.8h10.3a.789.789 0 01.8.8v.1a.789.789 0 01-.8.8zM58.1 34.2H47.8a.789.789 0 01-.8-.8v-.1a.789.789 0 01.8-.8h10.3a.789.789 0 01.8.8v.1a.789.789 0 01-.8.8zM58.1 38.2H47.8a.789.789 0 01-.8-.8v-.1a.789.789 0 01.8-.8h10.3a.789.789 0 01.8.8v.1a.789.789 0 01-.8.8zM58.1 45.6H31.3a.789.789 0 01-.8-.8v-.1a.789.789 0 01.8-.8h26.8a.789.789 0 01.8.8v.1a.789.789 0 01-.8.8zM43.5 38.4H32a1.538 1.538 0 01-1.5-1.5V30a1.538 1.538 0 011.5-1.5h11.6a1.538 1.538 0 011.5 1.5v6.8a1.718 1.718 0 01-1.6 1.6z"
            />
        </svg>
    );
}

export default SlideUploadIcon;
